module.exports = __webpack_public_path__ + "img/01.ef62f584.png";